export default {
  SET_AUTHORITY (state, data) {
    state.authority = data
  },
  SET_ADD_TAGVIEW (state, data){
    const ids = state.tagView.filter(el => el.path == data.path)
    // console.log(ids)
    if(!ids || !ids.length){
      state.tagView.push(data)
    }
  },
  SET_REMOVE_TAGVIEW (state, data){
    state.tagView.splice(data, 1)
  },
  SET_BREADCRUMBS (state, data){
    state.breadcrumbs = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js